module.exports = __webpack_public_path__ + "static/media/remolino-ventacruzada.21113c29.jpg";